import type { Dispatch, SetStateAction } from 'react'

import { createContext, useContext } from 'react'

interface Context {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

export const MenuContext = createContext<Context>({ open: true, setOpen: () => ({}) })

export function useMenu(): Context {
  return useContext(MenuContext)
}
